import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../styles/common.css';

function ParentSignup() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    familyName: '',
    children: [{ name: '', pin: '' }]
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleChildChange = (index, field, value) => {
    const newChildren = [...formData.children];
    newChildren[index][field] = value;
    setFormData(prev => ({
      ...prev,
      children: newChildren
    }));
  };

  const addChild = () => {
    if (formData.children.length < 5) {
      setFormData(prev => ({
        ...prev,
        children: [...prev.children, { name: '', pin: '' }]
      }));
    }
  };

  const removeChild = (index) => {
    if (formData.children.length > 1) {
      const newChildren = formData.children.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        children: newChildren
      }));
    }
  };

  // PIN 중복 확인 함수 (향후 사용 예정)
  // const checkPinAvailability = async (pin) => {
  //   if (pin.length >= 4) {
  //     try {
  //       const response = await api.get(`/auth/pins/check?pin=${pin}`);
  //       return response.data.available;
  //     } catch (error) {
  //       return false;
  //     }
  //   }
  //   return true;
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await api.post('/auth/parent/signup', formData);

      // 회원가입 성공 시 토큰 저장 및 대시보드로 이동
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));

      // 부모 대시보드로 리다이렉트
      navigate('/parent/dashboard');
    } catch (error) {
      setError(error.response?.data?.error || '회원가입 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <h1 className="title">👨‍👩‍👧‍👦 가족 등록</h1>
      <p className="subtitle">가족 정보를 입력해주세요</p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">부모님 이메일</label>
          <input
            type="email"
            name="email"
            className="form-input"
            value={formData.email}
            onChange={handleInputChange}
            required
            data-testid="email-input"
          />
        </div>

        <div className="form-group">
          <label className="form-label">비밀번호</label>
          <input
            type="password"
            name="password"
            className="form-input"
            value={formData.password}
            onChange={handleInputChange}
            required
            minLength="6"
            data-testid="password-input"
          />
        </div>

        <div className="form-group">
          <label className="form-label">부모님 이름</label>
          <input
            type="text"
            name="name"
            className="form-input"
            value={formData.name}
            onChange={handleInputChange}
            required
            data-testid="name-input"
          />
        </div>

        <div className="form-group">
          <label className="form-label">가족명</label>
          <input
            type="text"
            name="familyName"
            className="form-input"
            value={formData.familyName}
            onChange={handleInputChange}
            required
            placeholder="예: 김씨 가족"
            data-testid="family-name-input"
          />
        </div>

        <div style={{ marginTop: '30px', marginBottom: '20px' }}>
          <h3 style={{ color: '#333', fontSize: '1.2rem' }}>자녀 정보</h3>
        </div>

        {formData.children.map((child, index) => (
          <div key={index} style={{ marginBottom: '20px', padding: '15px', background: '#f8f9fa', borderRadius: '10px' }}>
            <div className="form-group">
              <label className="form-label">자녀 이름</label>
              <input
                type="text"
                className="form-input"
                value={child.name}
                onChange={(e) => handleChildChange(index, 'name', e.target.value)}
                required
                data-testid={`child-name-${index}`}
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">PIN (1-6자리 숫자)</label>
              <input
                type="text"
                className="form-input"
                value={child.pin}
                onChange={(e) => handleChildChange(index, 'pin', e.target.value)}
                required
                pattern="[0-9]{1,6}"
                placeholder="123456"
                data-testid={`child-pin-${index}`}
              />
            </div>
            
            {formData.children.length > 1 && (
              <button
                type="button"
                onClick={() => removeChild(index)}
                style={{ 
                  background: '#dc3545', 
                  color: 'white', 
                  border: 'none', 
                  padding: '5px 10px', 
                  borderRadius: '5px',
                  fontSize: '0.8rem'
                }}
              >
                삭제
              </button>
            )}
          </div>
        ))}

        {formData.children.length < 5 && (
          <button
            type="button"
            onClick={addChild}
            className="btn btn-secondary"
            style={{ fontSize: '0.9rem', padding: '10px 20px' }}
          >
            + 자녀 추가
          </button>
        )}

        {error && <div className="error" data-testid="error-message">{error}</div>}
        {success && <div className="success" data-testid="success-message">{success}</div>}

        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
          style={{ width: '100%', marginTop: '20px' }}
          data-testid="submit-btn"
        >
          {loading ? '등록 중...' : '가족 등록하기'}
        </button>
      </form>

      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <Link to="/parent/login" style={{ color: '#8B4513', textDecoration: 'none' }}>
          이미 계정이 있으신가요? 로그인하기
        </Link>
      </div>

      <div style={{ marginTop: '15px', textAlign: 'center' }}>
        <Link to="/" className="back-btn">
          ← 홈으로 돌아가기
        </Link>
      </div>
    </div>
  );
}

export default ParentSignup;